/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Subscriber module types
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.10.0
 */

import { IAuthRegion } from '../../pages/PageAuth/types/authTypes';

/*
* -------------------------------------------
*           Subscriber Regions
* -------------------------------------------
*/


export enum ESubscribersBasketRegionType {
    PRODUCT_OFFERINGS = 'PRODUCT_OFFERINGS',
    MOBILE = 'MOBILE',
}

export interface ISubscribersRegionsResponse {
    tarificationRegions: IAuthRegion[];
    // default region, if tarificationRegions is empty
    region?: IAuthRegion;
}
